import { reverse } from "@reactivated";

import { check } from "../models/utils";
import { VerificationStatusResponse } from "../models/verification";
import { CSRF_HEADER, fetchJson, getCSRFToken } from "../utils/ajax";

/**
 * Ask the server whether the current user already satisfies the verification
 * gate (or is exempt) for the given contact details, before any code is sent.
 * Lets the channel picker auto-pass without challenging an already-verified
 * or exempt user.
 */
export const getVerificationStatus = async (
    email: string | null,
    phone: string | null,
): Promise<VerificationStatusResponse> => {
    // POST (not GET) so email/phone travel in the body — the edge CDN strips
    // non-allowlisted query params, which would blank them on a GET.
    const body = await fetchJson(reverse("verification:status"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            [CSRF_HEADER]: await getCSRFToken(),
        },
        body: JSON.stringify({ email: email ?? "", phone: phone ?? "" }),
    });
    return check(VerificationStatusResponse.decode(body));
};
